import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl, ValidatorFn } from '@angular/forms';
import { UserService } from '../shared/services/user.service';
import { Router } from '@angular/router';
import { GlobalDataService } from 'src/app/shared/services/global-data.service';
import { IUserAppointmentSettingsModel } from '../shared/models/appointmentSettingsModel';
import { ToastService } from 'src/app/shared/services/toast.service';
import { HomeLocation } from '../shared/models/homeLocationsModel';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { IListItemModel } from '../shared/models/listItemModel';
import { MeetingPreference } from '../shared/models/meetingPreference.enum';
import { ConferencingServiceProviders } from '../shared/models/conferencingServiceProviders.enum';
import { IFloatLocationModel } from '../shared/models/floatLocationModel';
import { MasterLookupService } from 'src/app/master/master-services/master-lookup.service';
import { Timezone } from 'src/app/master/models/timeZone';
import EmailValidator from 'src/app/shared/validators/generic-email-validator';
import { DisableIfParam } from '../../location/directives/disableIfParameter';
import { getACClientConfiguration } from 'src/app/state';
import { takeWhile } from 'rxjs/operators';
import { ACClientConfiguration } from 'src/app/shared/models/acClientConfiguration';
import { Store } from '@ngrx/store';
import { State } from 'src/app/state/app.state';
import { TranslationLoaderFacade } from '../../localization/translation-loader.facade';
import { TranslateService } from '@ngx-translate/core';
import { UserEditDetails } from '../shared/models/userEditDetailsModel';
import { bookIcon } from '@progress/kendo-svg-icons';


@Component({
  selector: 'app-user-additional-settings',
  templateUrl: './user-additional-settings.component.html',
  styleUrls: ['./user-additional-settings.component.scss']
})
export class UserAdditionalSettingsComponent implements OnInit {

  @Output() closeEmitter = new EventEmitter();
  @Output() dirtyEmitter = new EventEmitter<boolean>(false);
  @Output() floatChangeEmitter = new EventEmitter<boolean>();
  @Output() useAppointmentChangeEmitter = new EventEmitter<boolean>(false);
  @Output() meetingPreferenceChangeEmitter = new EventEmitter<Array<IListItemModel>>();
  @Output() availabilityTempGridMeetingPreferenceUsage = new EventEmitter<boolean>();

  public additionalSettings: FormGroup = new FormGroup({
    prefferedTimezone: new FormControl(),
    flexibleFloatEmployee: new FormControl(),
    floatLocations: new FormControl(),
    useAppointments: new FormControl(),
    assignmentRank: new FormControl(),
    useEvents: new FormControl(),
    meetingPreferenceGroup: this.fb.group({
      allowInPersonAppointments: false,
      allowPhoneAppointments: false,
      allowVirtualAppointments: false,
      popIoExternalResourceId: ['']
    }),
    optInDailyPersonalEmails: new FormControl(),
    optInDailyLocationSummaryEmails: new FormControl(),
    secondaryNotificationEmail: new FormControl(),
    restrictAvailabilityOperatingHours: new FormControl(),
    secondaryEmailAsOptionalAttendee: new FormControl()
  });

  private popIoUserAlreadyExists: string = '';
  public popIoNotValidatedTooltip: string = '';
  public popIoValidationFailedTooltip: string = '';
  public popIoValidationSuccessTooltip: string = '';
  public popIoValidationStatus: boolean | null = null;
  public popIoResourceExtIdValidated: boolean | null = null;

  public prefferedTimezonesAvailable: Timezone[] = []; //= [{ id: 15, displayValue: '(UTC -5:00) Eastern Time (US and Canada) ' }, { id: 2, displayValue: 'Asia/Colombo' }, { id: 3, displayValue: 'Us/East' }];
  public selectedMeetingPreferece: IListItemModel | null = null;
  public revertingMeetingPreferenceCheckbox: string = '';
  public showReassignPopup: boolean = false;
  public locationList: HomeLocation[] = [];
  public conferencingProvider: string = '';
  public conferencingUserId: any = '';
  private externalUserId: string = '';
  public allowVirtualApp: boolean | null = null;
  public editingUserId: number | null = null;
  public allUserData: any;
  public anchor: any;
  public show: boolean = false;
  public isFloat: boolean = false;
  public showExtract: boolean = false;
  public isResetClicked: boolean = false;
  public meetingPreferenceConfiguration: any;
  public extractUserIdError: boolean = false;
  public showPopIoValidation: boolean = false;
  public appointmentsEnabled: boolean = false;
  public isAllLocationsChecked: boolean = false;
  public floatLocationList: HomeLocation[] = [];
  public reassignMeetingPreferenceList: Array<IListItemModel> = [
    { id: MeetingPreference.InPerson, displayValue: 'In-Person' },
    { id: MeetingPreference.Phone, displayValue: 'Phone' },
    { id: MeetingPreference.Virtual, displayValue: 'Virtual' }
  ];
  public dropdownSettings: IDropdownSettings = {};
  public conferencingProviderAuthenticationStatus: boolean = false;
  public isConferencingProviderAuthenticationStatusExtracted: boolean = false;
  public extracting: boolean =false;
  public selectAllText: string = '';
  public unselectAllText: string = '';

  // Reassing appointment meeting preferece
  @Output() emitReassignMeetingPreference = new EventEmitter<{ reassign: IListItemModel, as: IListItemModel }>();
  private reassigningMeetingPreferece: IListItemModel | undefined | null = null;
  private reassignByMeetingPreferece: IListItemModel | undefined | null = null;
  acClientConfiguration: ACClientConfiguration | null = null;
  mounted: boolean | null = null;

  // Common
  public meetingPreferenceList: Array<IListItemModel> = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private store: Store<State>,
    private userService: UserService,
    public toastService: ToastService,
    private lookupService: MasterLookupService,
    public globalDataService: GlobalDataService,
    private translationLoaderFacade: TranslationLoaderFacade, 
    private translateService: TranslateService
  ) {
    this.generateAdditionalSettingsForm();
    this.getHomeLocationList();
    this.getTimeZoneList();
    this.initializePopIOValidationMessages();
  }

  ngOnInit() {
    this.translateService.get(['_General_Select_All_Text_', '_General_Unselect_All_Ts_Text_']).subscribe(res => {
      this.selectAllText = res['_General_Select_All_Text_'];
      this.unselectAllText = res['_General_Unselect_All_Ts_Text_'];
    });
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'locationName',
      selectAllText: this.selectAllText,
      unSelectAllText: this.unselectAllText,
      itemsShowLimit: 3,
    };
    this.mounted = true;
    this.initMeetingPreferenceReassign();
    this.conferencingProvider = this.userService.conferencingProvider;

    this.store.select(getACClientConfiguration)
      .pipe(takeWhile(() => {
        if (this.mounted == undefined) {
          throw Error("this.mounted was undefined! Which was not expected!");
        }
        return this.mounted
      }))
      .subscribe(ecc => this.acClientConfiguration = ecc);
  }

  public loadAppointmentSettings() {
    let editingUserdata = this.userService.getEditingUser();

    if (editingUserdata) {
      this.editingUserId = editingUserdata?.userDetails?.userId;
      this.externalUserId = editingUserdata.userDetails.externalUserId;
      this.userService.getEditingUserDetails(this.editingUserId).subscribe((userData) => {
        if (userData.userDetails.virtualConferencingUserId != null || userData.userDetails.virtualConferencingUserId != "")
          this.popIoResourceExtIdValidated = true;
        this.lookupService.getPermissiongGroups().subscribe(p => {
          const permissionGroupName = p.filter(p => p.id == userData.userDetails.permissionGroupId)[0] as any;
          if (permissionGroupName.name == 'FMSI Default Group')
            this.additionalSettings?.get("useAppointments")?.disable();
        });

        this.allUserData = userData;
        this.conferencingUserId = this.allUserData.userDetails.virtualConferencingUserId;
        this.floatLocationList = userData.userAllowedWorkLocations;

        let preferredTimeZone = this.prefferedTimezonesAvailable.find(tz => tz.id == userData.userDetails.preferredTimeZone);
        if (preferredTimeZone == undefined) {
          throw Error("preferredTimeZone was undefined! Which was not expected!")
        }
        this.userService.setUserPreferedTimeZone(preferredTimeZone);

        this.additionalSettings.patchValue({
          prefferedTimezone: userData.userDetails.preferredTimeZone, //this.prefferedTimezonesAvailable[0].id,
          flexibleFloatEmployee: userData.userDetails.isFloat,
          floatLocations: [],
          useAppointments: userData.userDetails.appointmentsEnabled,
          assignmentRank: userData.userDetails.assignmentRank,
          useEvents: userData.userDetails.eventsEnabled,
          meetingPreferenceGroup: {
            allowInPersonAppointments: userData.userDetails.eligibleForInPersonAppointments,
            allowPhoneAppointments: userData.userDetails.eligibleForPhoneAppointments,
            allowVirtualAppointments: userData.userDetails.eligibleForVirtualAppointments,
            popIoExternalResourceId: userData.userDetails.virtualConferencingUserId
          },
          optInDailyPersonalEmails: userData.userDetails.optInDailyUserSummaryEmail,
          optInDailyLocationSummaryEmails: userData.userDetails.optInDailyLocationSummaryEmail,
          restrictAvailabilityOperatingHours: userData.userDetails.restrictAvailabilityOperatingHours,
          secondaryNotificationEmail: userData.userDetails.secondaryEmail,
          secondaryEmailAsOptionalAttendee: userData.userDetails.secondaryEmailAsOptionalEmailAttendee
        });
        this.enableDisableAssignmentRank(userData.userDetails.appointmentsEnabled);
        this.loadAppointmentOptionsStatus();

        this.showPopIoValidation = (this.conferencingProvider == ConferencingServiceProviders.PopIo);
        this.showExtract = (this.conferencingProvider == ConferencingServiceProviders.ZoomServerToServerOAuth ||this.conferencingProvider == ConferencingServiceProviders.ZoomOAuth || this.conferencingProvider == ConferencingServiceProviders.Zoom || this.conferencingProvider == ConferencingServiceProviders.Teams) ? true : false;
        if (!this.showExtract) {
          this.getConferencingProviderAuthenticationStatus();
        }

        if (this.showPopIoValidation)
          this.attachPopIoValidator();
      })
    }
    this.checkForDirty();
    this.userService.setOpenStatus(false);
  }

  private enableDisableAssignmentRank(appointmentEnabled: boolean) {
    if (appointmentEnabled) {
      this.additionalSettings.controls['assignmentRank'].enable();
    } else {
      this.additionalSettings.controls['assignmentRank'].disable();
    }
  }

  /**
  * Enable/ Disable meeting preference options according to the Client Settings
  * @param meetingPrefernces
  */
  public enableDisableAppointmentOptions(meetingPrefernces: any, setInPersonAppointment: boolean = false) {
    var useAppointment = this.additionalSettings?.get("useAppointments")?.value;

    const inpersonChk = this.additionalSettings.get('meetingPreferenceGroup.allowInPersonAppointments');
    const phoneChk = this.additionalSettings.get('meetingPreferenceGroup.allowPhoneAppointments');
    const virtualChk = this.additionalSettings.get('meetingPreferenceGroup.allowVirtualAppointments');

    this.enableDisableAssignmentRank(useAppointment);

    // the default value in the form is not taken, therefore this hack to explicity set the assignment rank
    // when appointment settings are enabled
    if (useAppointment && this.additionalSettings?.get("assignmentRank")?.value == "0") {
      this.additionalSettings.patchValue({
        assignmentRank: 1
      });
    }

    if (useAppointment) {
      if (meetingPrefernces) {
        this.meetingPreferenceConfiguration = JSON.parse(meetingPrefernces);

        if (this.meetingPreferenceConfiguration.inPerson) {
          inpersonChk?.enable();

          // Set in person pre-select if in person appointment enabled from AC side
          if (setInPersonAppointment) {
            inpersonChk?.setValue(this.meetingPreferenceConfiguration.inPerson);
          }
        } else {
          inpersonChk?.disable();
        }

        if (this.meetingPreferenceConfiguration.phone) {
          phoneChk?.enable();
        }
        else {
          phoneChk?.disable();
        }

        if (this.meetingPreferenceConfiguration.virtual) {
          virtualChk?.enable();
        }
        else {
          virtualChk?.disable();
        }
      }
    } else {
      inpersonChk?.disable();
      inpersonChk?.setValue(false);

      phoneChk?.disable();
      phoneChk?.setValue(false);

      virtualChk?.setValue(false);
      virtualChk?.disable();
    }

  }

  disableOptionalAttendeeCheckbox(): DisableIfParam {
    let disableCheckbox: boolean;
    let secondaryEmailValue = this.secondaryNotificationEmail?.value;
    let invalidEmailErr = this.secondaryNotificationEmail?.errors?.invalidEmail;

    if ((invalidEmailErr == undefined || invalidEmailErr == null)) {
      disableCheckbox = !secondaryEmailValue;
    } else disableCheckbox = invalidEmailErr;

    return {
      disable: disableCheckbox,
      message: this.translateService.instant('_User_Valid_Secondary_Notification_Email_Ts_Text_')
      //message: 'Enter a valid `Secondary Notification Email` in order to enable this checkbox.'
    }
  }

  allowInPersonOnlySelected(): DisableIfParam {
    var phone = this.additionalSettings?.get('meetingPreferenceGroup.allowPhoneAppointments')?.value;
    var virtual = this.additionalSettings?.get('meetingPreferenceGroup.allowVirtualAppointments')?.value;
    var inperson = this.additionalSettings?.get('meetingPreferenceGroup.allowInPersonAppointments')?.value;
    var appointmentEnabled = this.additionalSettings?.get('useAppointments')?.value;

    return (!phone && !virtual && inperson) ? {
      disable: true,
      message: this.translateService.instant('_General_Meeting_Preference_Option_Should_Select_Text_')
      //message: "At least one meeting preference option must be selected."
    } :
      {
        disable: appointmentEnabled ? (this.meetingPreferenceConfiguration != undefined && !this.meetingPreferenceConfiguration.inPerson) : true,
        message: ''
      }
  }

  allowPhoneOnlySelected(): DisableIfParam {
    var virtual = this.additionalSettings?.get('meetingPreferenceGroup.allowVirtualAppointments')?.value;
    var person = this.additionalSettings?.get('meetingPreferenceGroup.allowInPersonAppointments')?.value;
    var phone = this.additionalSettings?.get('meetingPreferenceGroup.allowPhoneAppointments')?.value;
    var appointmentEnabled = this.additionalSettings?.get('useAppointments')?.value;

    return (!person && !virtual && phone) ? {
      disable: true,
      message: this.translateService.instant('_General_Meeting_Preference_Option_Should_Select_Text_')
      //message: "At least one meeting preference option must be selected."
    } :
      {
        disable: appointmentEnabled ? (this.meetingPreferenceConfiguration != undefined && !this.meetingPreferenceConfiguration.phone) : true,
        message: ''
      }
  }

  allowVirtualOnlySelected(): DisableIfParam {
    var phone = this.additionalSettings?.get('meetingPreferenceGroup.allowPhoneAppointments')?.value;
    var person = this.additionalSettings?.get('meetingPreferenceGroup.allowInPersonAppointments')?.value;
    var virtual = this.additionalSettings?.get('meetingPreferenceGroup.allowVirtualAppointments')?.value;
    var appointmentEnabled = this.additionalSettings?.get('useAppointments')?.value;

    return (!person && !phone && virtual) ? {
      disable: true,
      message: this.translateService.instant('_General_Meeting_Preference_Option_Should_Select_Text_')
      //message: "At least one meeting preference option must be selected."
    } :
      {
        disable: appointmentEnabled ? (this.meetingPreferenceConfiguration != undefined && !this.meetingPreferenceConfiguration.virtual) : true,
        message: ''
      }
  }

  get secondaryNotificationEmail() {
    return this.additionalSettings.get('secondaryNotificationEmail');
  }

  /**
   * Generate the form and assign default values to the form
   */
  public generateAdditionalSettingsForm() {
    this.additionalSettings = this.fb.group({
      prefferedTimezone: new FormControl(),
      flexibleFloatEmployee: [false],
      floatLocations: [[], []],
      useAppointments: [false],
      assignmentRank: [0, [Validators.pattern('^([1-9][0-9]?)$')]],
      useEvents: [false],
      meetingPreferenceGroup: this.fb.group({
        allowInPersonAppointments: false,
        allowPhoneAppointments: false,
        allowVirtualAppointments: false,
        popIoExternalResourceId: ['']
      }),
      optInDailyPersonalEmails: [false],
      optInDailyLocationSummaryEmails: [false],
      secondaryNotificationEmail: ['', [EmailValidator()]],
      restrictAvailabilityOperatingHours: [false],
      secondaryEmailAsOptionalAttendee: [false]
    });
  }

  attachPopIoValidator() {
    this.additionalSettings?.get('meetingPreferenceGroup.allowVirtualAppointments')?.valueChanges.subscribe(val => {
      if (val) {
        this.popIoResourceExtIdValidated = this.popIoExternalResourceId?.value == "" ? false : null;
        this.popIoExternalResourceId?.setValidators(Validators.required)
      } else {
        this.popIoExternalResourceId?.clearValidators();
        this.popIoExternalResourceId?.setValue(null);
        this.popIoResourceExtIdValidated = null;
      }

      this.popIoExternalResourceId?.updateValueAndValidity();
    });
  }

  // Form Getters
  get popIoExternalResourceId() {
    return this.additionalSettings.get('meetingPreferenceGroup.popIoExternalResourceId');
  }

  public onPopIoExternalResourceIdChange() {
    this.popIoResourceExtIdValidated = false;
    if (this.popIoValidationStatus != null)
      this.popIoValidationStatus = null;
  }

  public popIoExternalResourceIdValidation(event: MouseEvent) {
    event.preventDefault();
    this.initializePopIOValidationMessages();
    this.userService.validatePopIoResourceExternalId(this.externalUserId, this.popIoExternalResourceId?.value).subscribe(validationResponse => {
      this.popIoValidationStatus = validationResponse.isValid;
      if (!validationResponse.doesNotExist)
        this.popIoValidationFailedTooltip = this.popIoUserAlreadyExists;
      this.popIoResourceExtIdValidated = true;
    }, error => {
      console.error(error);
      this.popIoValidationStatus = false;
      this.popIoResourceExtIdValidated = false;
    });
  }

  private initializePopIOValidationMessages() {
    this.popIoNotValidatedTooltip = this.translateService.instant('_User_Additional_Settings_PopIO_Resource_External_Id_Not_Validated_Text_');
    this.popIoValidationSuccessTooltip = this.translateService.instant('_User_Additional_Settings_PopIO_Resource_External_Id_Validation_Success_Text_');
    this.popIoValidationFailedTooltip = this.translateService.instant('_User_Additional_Settings_PopIO_Resource_External_Id_Validation_Failed_Text_');
    this.popIoUserAlreadyExists = this.translateService.instant('_User_Additional_Settings_PopIO_Resource_External_Id_In_Use_Text_');
  }



  /**
   * Get all the locations (Since the permission module is not completed yet)
   */
  getHomeLocationList() {
    this.userService.getLHomeLocations(5).subscribe((response: HomeLocation[]) => {
      this.locationList = response;
      if (this.locationList.length == 0) {
        this.additionalSettings.controls['floatLocations'].disable();
      }
    });
  }

  getTimeZoneList() {
    this.lookupService.getTimeZones().subscribe((response: Timezone[]) => {
      this.prefferedTimezonesAvailable = response;
      this.additionalSettings.patchValue({
        prefferedTimezone: this.prefferedTimezonesAvailable[0].id
      });
      this.userService.setUserPreferedTimeZone(this.prefferedTimezonesAvailable[0]);
      this.loadAppointmentSettings();
    });
  }

  /**
   * Notify if there are unsaved changed in this child form to the parent form
   */
  public checkForDirty() {
    this.additionalSettings.valueChanges.subscribe(value => {
      var dirtyValues = this.getDirtyValues(this.additionalSettings);
      if (dirtyValues != undefined && Object.keys(dirtyValues).length > 0) {
        this.dirtyEmitter.emit(true);
        this.additionalSettings.markAsDirty()
      }
      else {
        this.dirtyEmitter.emit(false);
        this.additionalSettings.markAsPristine()
      }
    });
  }

  /**
   * Omit the floatLocations and set floatLocation dirty at @onFloatLocationSelect() method
   * @param form form object
   * @returns object with dirty keys
   */
  getDirtyValues(form: any) {
    let dirtyValues: { [key: string]: any } = {};
    Object.keys(form.controls)
      .forEach(key => {
        if (key != 'floatLocations') {
          const currentControl = form.controls[key];
          if (currentControl.dirty) {
            if (currentControl.controls)
              dirtyValues[key] = this.getDirtyValues(currentControl);
            else
              dirtyValues[key] = currentControl.value;
          }
        }

      });
    return dirtyValues;
  }

  /**
   * Save all the unsaved additional settings data
   */
  submitAdditionalSettings() {
    if (this.editingUserId == null) {
      throw Error("this.editingUserId was null! Which was not expected!")
    }
    let appointmentSetttings = new IUserAppointmentSettingsModel();
    appointmentSetttings.UserId = this.editingUserId;
    appointmentSetttings.SecondaryNotificationEmail = this.additionalSettings.controls.secondaryNotificationEmail.value;
    appointmentSetttings.SecondaryEmailAsOptionalAttendee = this.additionalSettings.controls.secondaryEmailAsOptionalAttendee.value;
    appointmentSetttings.PreferredTimeZone = this.additionalSettings.controls.prefferedTimezone.value;
    appointmentSetttings.OptInDailyUserSummaryEmail = this.additionalSettings.controls.optInDailyPersonalEmails.value;
    appointmentSetttings.OptInDailyBranchSummaryEmail = this.additionalSettings.controls.optInDailyLocationSummaryEmails.value;
    appointmentSetttings.RestrictAvailabilityOperatingHours = this.additionalSettings.controls.restrictAvailabilityOperatingHours.value;
    appointmentSetttings.IsFloat = this.additionalSettings.controls.flexibleFloatEmployee.value;
    appointmentSetttings.FloatLocations = appointmentSetttings.IsFloat ? this.getFloatLocations(this.additionalSettings.controls.floatLocations.value) : [];
    appointmentSetttings.EligibleForInPersonAppointments = this.additionalSettings?.get('meetingPreferenceGroup.allowInPersonAppointments')?.value;
    appointmentSetttings.EligibleForPhoneAppointments = this.additionalSettings?.get('meetingPreferenceGroup.allowPhoneAppointments')?.value;
    appointmentSetttings.EligibleForVirtualAppointments = this.additionalSettings?.get('meetingPreferenceGroup.allowVirtualAppointments')?.value;
    appointmentSetttings.AppointmentsEnabled = this.additionalSettings.controls.useAppointments.value;
    appointmentSetttings.AssignmentRank = this.additionalSettings.controls.assignmentRank.value;
    appointmentSetttings.EventsEnabled = this.additionalSettings.controls.useEvents.value;

    if (this.conferencingProvider == ConferencingServiceProviders.PopIo) {
      appointmentSetttings.VirtualConferencingUserId = this.popIoExternalResourceId?.value;
    } else {
      appointmentSetttings.VirtualConferencingUserId = this.conferencingUserId;
    }

    this.userService.updateAppointmentSettings(appointmentSetttings, this.editingUserId).subscribe((data) => {
      if (this.editingUserId == null) {
        throw Error("this.editingUserId was null! Which was not expected!")
      }
      this.userService.getEditingUserDetails(this.editingUserId).subscribe((userData: UserEditDetails) => {
        this.userService.setEditingUser(userData);
        this.toastService.showSuccess('_General_Changes_Saved_Successfully_Ts_Text_');
        this.additionalSettings.markAsPristine();
        this.dirtyEmitter.emit(false);
      },
        error => {
          console.log(error);
          this.toastService.showError('_General_Saving_Failed_Ts_Text_');

        })

    }, error => {
      console.log(error);
      this.toastService.showError('_General_Saving_Failed_Ts_Text_');

    })
  }
  /**
  * Get selected Float Locations
  * @param selectedFloatLocations
  * @returns
  */
  public getFloatLocations(selectedFloatLocations: HomeLocation[]) {
    let floatLocationsPostModel: IFloatLocationModel[] = [];
    if (selectedFloatLocations.length > 0) {
      selectedFloatLocations.forEach(floatLocation => {
        if (this.editingUserId == null) {
          throw Error("this.editingUserId was null! Which was not expected!")
        }
        floatLocationsPostModel.push({ userId: this.editingUserId, locationId: floatLocation.id });
      });
    }
    return floatLocationsPostModel;
  }

  /**
   * Close the accordion panel without reverting the changes when clicking on the Close button
   */
  public cancelClicked() {
    if (this.userService.getEditingUser()) {
      this.closeEmitter.emit('ngb-panel-3');
    } else {
      this.additionalSettings.reset();
    }
  }

  /**
   * Setting the selection of float location required, if the user is a flexible float employee
   */
  public floatEmployeeChange() {
    this.isAllLocationsChecked = false;
    this.userService.availabilityLocation(this.additionalSettings?.get("flexibleFloatEmployee")?.value);
    // Set the floating value to shared model

    var editinguser = this.userService?.getEditingUser();
    if (editinguser == null) {
      throw Error("editinguser was null! Which was not expected!")
    }
    this.userService.getEditingUser()!.userDetails.isFloat = this.additionalSettings?.get("flexibleFloatEmployee")?.value;
    this.floatChangeEmitter.emit();
    if (this.additionalSettings?.get("flexibleFloatEmployee")?.value) {
      this.floatLocationList = [];
    }

  }

  /**
   * Enable and Disable Appointment related options according to the state of the Use Appointment value
   */
  public loadAppointmentOptionsStatus() {
    this.userService.meetingPreferencData.subscribe(preferences => {
      this.enableDisableAppointmentOptions(preferences);
    });
    this.useAppointmentChangeEmitter.emit(this.additionalSettings?.get("useAppointments")?.value);
  }

  /**
   * Enable/disable Appointment related options according to the state of the Use Appointment value and emit the changes to the availablity temp grid
   */
  public useAppointmentsChange() {
    var useAppointment = this.additionalSettings?.get("useAppointments")?.value;
    if (!useAppointment) {
      this.userService.confUserId = null;
    }

    this.userService.meetingPreferencData.subscribe(preferences => {
      this.enableDisableAppointmentOptions(preferences, true);
    });
    this.setSelectedMeetingPreferenceValues();
    // set default values for the assignment rank
    this.additionalSettings?.get("assignmentRank")?.setValue(useAppointment ? 1 : 0);
    this.useAppointmentChangeEmitter.emit(useAppointment);
  }

  public onFocusOutAssignmentRank() {
    var assignmentRank = this.additionalSettings?.get("assignmentRank")?.value;
    if (assignmentRank == "" || assignmentRank < 1 || assignmentRank > 100 || isNaN(assignmentRank)) {
      this.additionalSettings.controls.assignmentRank.setValue("");
      this.additionalSettings.controls.assignmentRank.setValue(1);
    }
  }

  /**
   * Toggles the enabled disbaled property of the link
   */
  public resetClickedByUser() {
    this.isResetClicked = true;
  }


  /**
   * Shows the users the password reset link
   */
  public onToggle(): void {
    this.show = !this.show;
  }


  /**
   * Executes the functionality related to copy to clipboard
   */
  public copyInputMessage(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
  /**
   * Extract users virtual conferencing user id
   */
  public getConferencingUserId() {
    this.doGetConferencingUserId(true);

  }

  public doGetConferencingUserId(initalLoding: boolean = false) {
    this.extracting=true;
    this.userService.getConferencingUserId().subscribe({
      next: (data) => {
        this.extracting=false;;
        this.conferencingUserId = data;
        this.userService.confUserId = this.allowVirtualApp ? this.conferencingUserId : null
        this.extractUserIdError = false;
        if (!initalLoding) {
          this.additionalSettings.markAsDirty();
        }
      },
      error: () => {
        this.extractUserIdError = true;
        this.extracting=false;
      }
    });
  }


  public getConferencingProviderAuthenticationStatus() {

    this.userService.getConferencingProviderAuthenticationStatus().subscribe({
      next: (data) => {
        this.conferencingProviderAuthenticationStatus = JSON.parse(data.toLowerCase());
        this.isConferencingProviderAuthenticationStatusExtracted = true;
      },
      error: () => {
        this.isConferencingProviderAuthenticationStatusExtracted = false;
        this.toastService.showError('_User_Settings_Conference_Authentication_Fail_Text_');
      }
    });
  }

  /**
   * Change the availability template grid data when checking/ unchecking Allow In-Person Appointments
   */
  public allowInPersonAppointmentsChange() {
    if (!this.additionalSettings?.get('meetingPreferenceGroup.allowInPersonAppointments')?.value) {
      this.uncheckMeetingPreference('meetingPreferenceGroup.allowInPersonAppointments', MeetingPreference.InPerson);
    }
    else {
      this.setSelectedMeetingPreferenceValues();
    };
  }

  /**
   * Change the availability template grid data when checking/ unchecking Allow Phone Appointments
   */
  public allowPhoneAppointmentsChange() {
    if (!this.additionalSettings?.get('meetingPreferenceGroup.allowPhoneAppointments')?.value) {
      this.uncheckMeetingPreference('meetingPreferenceGroup.allowPhoneAppointments', MeetingPreference.Phone);
    }
    else {
      this.setSelectedMeetingPreferenceValues();
    };
  }

  /**
   * Change the availability template grid data when checking/ unchecking Allow Virtual Appointments
   */
  public allowVirtualAppointmentsChange() {
    this.extractUserIdError = false;
    if (!this.additionalSettings?.get('meetingPreferenceGroup.allowVirtualAppointments')?.value) {
      this.uncheckMeetingPreference('meetingPreferenceGroup.allowVirtualAppointments', MeetingPreference.Virtual);
      this.userService.confUserId = null;
    }
    else {
      this.userService.confUserId = this.conferencingUserId;
      this.setSelectedMeetingPreferenceValues();
    };

    this.popIoExternalResourceId?.markAsUntouched();
  }

  /**
   * If the unchecking meeting preference is not the only enabled meeting preference,
   * If there are days which are opted in only for the unchecking meeting preference,
   * Display Reasign popup
   * @param controllerName
   * @param meetingPreferenceId
   */
  public uncheckMeetingPreference(controllerName: string, meetingPreferenceId: number) {
    if (this.getSelectedMeetingPreferenceOptions().length == 0) {
      this.additionalSettings?.get(controllerName)?.setValue(true);
    }
    else {
      if (this.hasUsedTheUncheckedMeetingPreferenceOption(meetingPreferenceId)) {
        this.assignReassigningMeetingPreferences(controllerName, meetingPreferenceId);
      }
      else {
        this.setSelectedMeetingPreferenceValues();
      }
    };
  }

  /**
   * Showing Reasign popup with the available reassign options
   * @param meetingPreferenceOption
   */
  public assignReassigningMeetingPreferences(meetingPreferenceOption: string, meetingPreferenceId: number) {
    this.reassignMeetingPreferenceList = this.getSelectedMeetingPreferenceOptions();
    this.selectedMeetingPreferece = this.reassignMeetingPreferenceList[0];
    this.revertingMeetingPreferenceCheckbox = meetingPreferenceOption;

    this.reassigningMeetingPreferece = this.meetingPreferenceList.filter(lm => lm.id == meetingPreferenceId)[0];
    this.reassignByMeetingPreferece = this.meetingPreferenceList.filter(lm => lm.id == this.selectedMeetingPreferece?.id)[0];

    this.showReassignPopup = true;
  }

  /**
   * Get all the enabled meeting preference options
   * @returns Enabled meeting preference options list
   */
  public getSelectedMeetingPreferenceOptions() {
    var selectedList = [];
    const inpersonChk = this.additionalSettings.get('meetingPreferenceGroup.allowInPersonAppointments');
    const phoneChk = this.additionalSettings.get('meetingPreferenceGroup.allowPhoneAppointments');
    const virtualChk = this.additionalSettings.get('meetingPreferenceGroup.allowVirtualAppointments');

    if (inpersonChk?.value) selectedList.push({ id: MeetingPreference.InPerson, displayValue: 'In-Person' });
    if (phoneChk?.value) selectedList.push({ id: MeetingPreference.Phone, displayValue: 'Phone' });
    if (virtualChk?.value) selectedList.push({ id: MeetingPreference.Virtual, displayValue: 'Virtual' });

    return selectedList;
  }

  /**
   * Changing availability template meeting preferences drop down values and selections
   * according to the enabled meeting preference options in Appointment settings
   */
  public setSelectedMeetingPreferenceValues() {
    var selectedMeetingPref = this.getSelectedMeetingPreferenceOptions();
    this.meetingPreferenceChangeEmitter.emit(selectedMeetingPref);
  }

  public setReasignedMeetingPreferenceValues() {
    this.reassignByMeetingPreferece = this.selectedMeetingPreferece;

    if (this.reassigningMeetingPreferece == undefined || this.reassigningMeetingPreferece == null) {
      throw Error("this.reassigningMeetingPreferece was undefined or null! Which was not expected!")
    }
    if (this.selectedMeetingPreferece == null) {
      throw Error("this.selectedMeetingPreferece was undefined or null! Which was not expected!")
    }

    this.emitReassignMeetingPreference.emit({ reassign: this.reassigningMeetingPreferece, as: this.selectedMeetingPreferece });
  }

  /**
   * Check whether if there are days which are opted in only for unckecking meeting preference option
   * @param uncheckedMeetingPreferenceId
   * @returns
   */
  public hasUsedTheUncheckedMeetingPreferenceOption(uncheckedMeetingPreferenceId: number) {
    var hasUsedMeetingPreferenceInAvailabilityTempGrid = false;
    this.userService.avialabilityTempGridDataSet.forEach(element => {
      element.availabilityTempateDay.forEach(day => {
        day.availabilityTimeRange.forEach(timerange => {
          switch (uncheckedMeetingPreferenceId) {
            case (MeetingPreference.InPerson):
              if ((timerange.eligibleForInPersonAppointments) && (timerange.selectedMeetingPreference.length == 1)) hasUsedMeetingPreferenceInAvailabilityTempGrid = true;
              break;
            case (MeetingPreference.Phone):
              if ((timerange.eligibleForPhoneAppointments) && (timerange.selectedMeetingPreference.length == 1)) hasUsedMeetingPreferenceInAvailabilityTempGrid = true;
              break;
            case (MeetingPreference.Virtual):
              if ((timerange.eligibleForVirtualAppointments) && (timerange.selectedMeetingPreference.length == 1)) hasUsedMeetingPreferenceInAvailabilityTempGrid = true;
              break;
            default:
              break;
          }
        })
      })
    })
    return hasUsedMeetingPreferenceInAvailabilityTempGrid;
  }

  /**
   * Reassign confirmation
   */
  public onReassignMeetingPreference() {
    this.setReasignedMeetingPreferenceValues();
    this.showReassignPopup = false;
  }

  /**
   * Reassign Cancelation
   */
  public cancelMeetingPreferenceReassign() {
    this.additionalSettings?.get(this.revertingMeetingPreferenceCheckbox)?.setValue(!this.additionalSettings?.get(this.revertingMeetingPreferenceCheckbox)?.value);
    this.showReassignPopup = false;
    this.initMeetingPreferenceReassign();
  }


  /**
   * Location selector 'All' checkbox click event
   */
  public onLocationSelectorAllClick() {
    this.isAllLocationsChecked = !this.isAllLocationsChecked
    this.floatLocationList = this.isAllLocationsChecked ? this.locationList.slice() : [];
  }

  // Init meeting preference reassign popup variables
  private initMeetingPreferenceReassign() {
    this.meetingPreferenceList = [{ id: MeetingPreference.InPerson, displayValue: 'In-Person' }, { id: MeetingPreference.Phone, displayValue: 'Phone' }, { id: MeetingPreference.Virtual, displayValue: 'Virtual' }];

    this.reassigningMeetingPreferece = undefined;
    this.reassignByMeetingPreferece = undefined;
  }

  public numbersOnly(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  public onPrefferedTimeZoneChange() {
    let preferredTimeZone = this.prefferedTimezonesAvailable.find(tz => tz.id == this.additionalSettings.controls.prefferedTimezone.value);
    if (preferredTimeZone == undefined) {
      throw Error("preferredTimeZone was undefined! Which was not expected!")
    }
    this.userService.setUserPreferedTimeZone(preferredTimeZone);
  }

  /**
   * Set form dirty on multi select,
   * since the patch always makes the multi select dirty
   */
  public onFloatLocationSelect() {
    this.additionalSettings.markAsDirty();
    this.dirtyEmitter.emit(true);
  }


  public isSecondaryNotificationEmailInvalid(secondaryNotificationEmail: any):boolean{
    return secondaryNotificationEmail.invalid;
  }

  public isAnyMeetingPreferenceOptionNotSelected():boolean{
    return this.additionalSettings.get('useAppointments')?.value && this.getSelectedMeetingPreferenceOptions().length == 0;
  }

  public isSaveButtonDisabled():boolean{
    var disabled = (this.popIoValidationStatus == false || (this.popIoResourceExtIdValidated != null 
      && !this.popIoResourceExtIdValidated) || !this.additionalSettings.valid  
      || !this.additionalSettings.dirty|| (this.isFloat && this.floatLocationList.length == 0)) 
      || ((!this.additionalSettings.valid && (this.isFloat && this.floatLocationList.length == 0)) 
      && (this.conferencingUserId==undefined)) ||(this.additionalSettings.get('useAppointments')?.value 
      && this.getSelectedMeetingPreferenceOptions().length == 0);
    return disabled;
  }
  onFloatLocationDeSelect(event: any): void {
    // Mark the floatLocations control as dirty to enable the save button
    this.additionalSettings.get('floatLocations')?.markAsDirty();
  }
}
